import React from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { useSystem } from '../../features/system/hook'
import queryString from 'query-string'
import { setStatus } from '../../features/organizations/slice'
import { useDispatch } from 'react-redux'
import { Chip as Label } from '../chip'
import { QUERY_BLACKLIST as BLACKLIST } from '../../constants'

const Labels = ({query, wrap}) => {
  const {
    audienceOptions,
    approachOptions,
    issueOptions,
    organizationTypeOptions,
    categoryResourceOptions,
    categoryBlogOptions,
    typeResourceOptions
  } = useSystem()
  const [labels, setLabels] = React.useState([])
  const location = useLocation()
  const history = useHistory()
  const dispatch = useDispatch()

  const renderQueries = React.useCallback(() => {
    let result = []
    const isResource = location.pathname === '/resource'

    function pushToResult(options, id, key){
      const data = options.find(a => a.value === parseInt(id))
      if(data) result.push({...data, key})
    }

    const optionsBank = {
      // form key: array of options values
      audience: audienceOptions,
      approach: approachOptions,
      issue: issueOptions,
      type: organizationTypeOptions,
      category: isResource ? categoryResourceOptions : categoryBlogOptions,
      typeResource: typeResourceOptions
    }

    let options = []

    for(let k in query){

      const allowDirectPush = k === 'keyword'
        || k === 'province'
        || k === 'provinsi'
        || k === 'city'
        || k === 'kota'
        || k === 'startRentangWaktu'
        || k === 'endRentangWaktu'

      if(!BLACKLIST.includes(k)){
        if(allowDirectPush) {
          result.push({
            key: k,
            label: query[k],
            value: query[k]
          })
        } else {
          if(optionsBank[k]){
            options = optionsBank[k]
          }

          if(query[k]){
            // Single value
            if(typeof query[k] === 'string'){
              const id = query[k]
              pushToResult(options, id, k)
            }
            // Array value
            else if(typeof query[k] === 'object' && query[k].length > 0) {
              for (let index = 0; index < query[k].length; index++) {
                const id = query[k][index];
                pushToResult(options, id, k)
              }
            }
          }
        }
      }
    }

    console.log({result})

    setLabels(result)
  }, [query, approachOptions, issueOptions, organizationTypeOptions, categoryBlogOptions, categoryResourceOptions, audienceOptions, typeResourceOptions, location.pathname])

  React.useEffect(() => {
    if(query){
      renderQueries()
    }
  }, [query, renderQueries])

  const handleClick = (data) => {
    const toRemove = `${data.key}=${encodeURI(data.value)}`
    const currentQueries = location.search
    const newQueries = currentQueries.replace(toRemove, '')

    // Remove unnecessary '?' and '&' from query string
    const query = queryString.parse(newQueries)
    const searchString = queryString.stringify(query)

    dispatch(setStatus('idle'))

    history.replace({
      search: searchString
    })
  }

  return (
    <div className={`filter-items flex ${wrap ? 'flex-wrap' : ''} items-center`}>
      {
        labels &&
        labels.map((l, i) => (
          <div className="mr-2 mb-2" key={i}><Label onClick={() => handleClick(l)}>{l.label}</Label></div>
        ))
      }
    </div>
  )
}

export { Labels }
